import React, { useEffect, useState } from "react";
import axios from "axios";
import { API } from "../../constants";

/**
 * CodesInUseBar — top-of-dashboard promo code usage strip.
 * Shows each active promo's used/cap ratio with a progress bar.
 */
export default function CodesInUseBar() {
  const [data, setData] = useState(null);

  useEffect(() => {
    axios.get(`${API}/crm/promo-stats`).then((r) => setData(r.data)).catch(() => {});
  }, []);

  if (!data) return null;

  return (
    <div className="card-glass p-4 mb-6" data-testid="codes-in-use-bar">
      <div className="flex items-center gap-2 mb-3">
        <svg className="w-4 h-4 text-[#A3E635]" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
          <path d="M15 5v2m0 4v2m0 4v2M5 5a2 2 0 00-2 2v3a2 2 0 110 4v3a2 2 0 002 2h14a2 2 0 002-2v-3a2 2 0 110-4V7a2 2 0 00-2-2H5z" />
        </svg>
        <h3 className="font-heading text-white font-semibold text-sm">Promo Code Usage</h3>
        <span className="ml-auto text-xs text-[#E8E4DC]/60">
          <span className="text-[#A3E635] font-semibold" data-testid="codes-lifetime-users">{data.lifetime_users}</span> lifetime ·{" "}
          <span className="text-red-400 font-semibold" data-testid="codes-refunded">{data.refunded}</span> refunded
        </span>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-2">
        {data.codes.map((c) => {
          const full = c.cap != null && c.used >= c.cap;
          const pctUsed = c.cap ? Math.min(100, Math.round((c.used / c.cap) * 100)) : 0;
          return (
            <div
              key={c.code}
              className={`px-3 py-2 rounded-lg border ${full ? "bg-red-500/10 border-red-500/30" : "bg-white/5 border-white/10"}`}
              data-testid={`code-stat-${c.code}`}
            >
              <p className="text-white text-xs font-mono font-semibold truncate">{c.code}</p>
              <p className="text-[#A3E635] text-xs font-bold">
                {c.used}{c.cap != null ? ` / ${c.cap}` : ""}
                {c.cap != null && full && <span className="text-red-400 ml-1">FULL</span>}
              </p>
              {c.cap != null && (
                <div className="mt-1 h-1 w-full bg-white/10 rounded-full overflow-hidden">
                  <div className="h-full bg-[#A3E635]" style={{ width: `${pctUsed}%` }} />
                </div>
              )}
              <p className="text-[#E8E4DC]/50 text-[10px] mt-0.5 truncate">{c.label}</p>
            </div>
          );
        })}
      </div>
    </div>
  );
}
